import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.number.is-integer.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import infoList from "@/mixins/infoList";
import { editAccountInfo, getMerchantAccountInfo } from "@/api/merchantOrder";
export default {
  name: "ContactList",
  mixins: [infoList],
  data: function data() {
    var checkEmail = function checkEmail(rule, value, callback) {
      var mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (!value) {
        return callback(new Error('邮箱不能为空'));
      }
      setTimeout(function () {
        if (mailReg.test(value)) {
          callback();
        } else {
          callback(new Error('请输入正确的邮箱格式'));
        }
      }, 100);
    };
    var checkPhone = function checkPhone(rule, value, callback) {
      var phoneReg = /[0-9]{10}$/;
      if (!value) {
        return callback(new Error('电话号码不能为空'));
      }
      setTimeout(function () {
        // Number.isInteger是es6验证数字是否为整数的方法,实际输入的数字总是识别成字符串
        // 所以在前面加了一个+实现隐式转换

        if (!Number.isInteger(+value)) {
          callback(new Error('请输入数字值'));
        } else {
          console.log(value);
          if (phoneReg.test(value)) {
            callback();
          } else {
            callback(new Error('电话号码格式不正确'));
          }
        }
      }, 100);
    };
    return {
      editDialogVisible: false,
      listApi: getMerchantAccountInfo,
      editContactList: {
        id: '',
        status: true,
        name: '',
        bankAccountNo: '',
        panNo: '',
        IFSCCode: '',
        bankName: '',
        address: '',
        iPhone: '',
        email: '',
        vpa: '',
        remark: ''
      },
      rules: {
        name: [{
          required: false,
          message: '请输入联系人名称',
          trigger: 'blur'
        }],
        bankAccountNo: [{
          required: false,
          message: '请输入银行账户',
          trigger: 'blur'
        }],
        panNo: [{
          required: true,
          message: '请输入PanNo',
          trigger: 'blur'
        }],
        IFSCCode: [{
          required: true,
          message: '请输入身份证账号',
          trigger: 'blur'
        }],
        bankName: [{
          required: false,
          message: '请输入银行名称',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: '请输入联系地址',
          trigger: 'blur'
        }],
        iPhone: [{
          validator: checkPhone,
          trigger: 'blur'
        }, {
          required: true,
          message: '请输入联系地址',
          trigger: 'blur'
        }],
        email: [{
          validator: checkEmail,
          trigger: 'blur'
        }, {
          required: true,
          message: '请输入ChannelId联系地址',
          trigger: 'blur'
        }],
        vpa: [{
          required: false,
          message: '请输入vpa',
          trigger: 'blur'
        }]
      },
      formLabelWidth: '200px'
    };
  },
  methods: {
    editContact: function editContact(row) {
      for (var key in this.editContactList) {
        this.editContactList[key] = row[key];
      }
      console.log(this.editContactList);
      this.editDialogVisible = true;
    },
    confirmContact: function confirmContact() {
      var _this = this;
      this.$refs.editContactListFromref.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          var res;
          return regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!valid) {
                  _context.next = 3;
                  break;
                }
                _context.next = 1;
                return editAccountInfo(_this.editContactList);
              case 1:
                res = _context.sent;
                if (!(res.code == 0)) {
                  _context.next = 3;
                  break;
                }
                _this.$message.success(res.msg);
                _context.next = 2;
                return _this.getTableData();
              case 2:
                _this.editDialogVisible = false;
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    closeEditDialog: function closeEditDialog() {
      this.$refs.editContactListFromref.resetFields();
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (_this2.$store.getters['user/merchantGrade'] !== 1) {
              _this2.searchInfo.MerchantId = _this2.$store.getters['user/merchantId'];
            }
            _context2.next = 1;
            return _this2.getTableData();
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }
};